import { InjectionToken } from '@angular/core';

export const CONNECTED_DIALOG_DATA = new InjectionToken<{}>('CONNECTED_DIALOG_DATA');